import {
  USER_CREATED,
  USER_FETCHED,
  USERS_FETCHED,
  USER_DELETED,
} from 'constants/actions';
import apiClient from 'helpers/api-client';

function userCreated(user) {
  return {
    type: USER_CREATED,
    user,
  };
}

function userFetched(user) {
  return {
    type: USER_FETCHED,
    user,
  };
}

function usersFetched(users) {
  return {
    type: USERS_FETCHED,
    users,
  };
}

function userDeleted(userId) {
  return {
    type: USER_DELETED,
    userId,
  };
}

function createUser(user) {
  return (dispatch, getState) => {
    const state = getState();
    const companyId = state.user.company_id;
    return apiClient
      .post(`companies/${companyId}/users`, { user })
      .then((createdUser) => {
        dispatch(userCreated(createdUser));
        return createdUser;
      });
  };
}

function updateUser(userId, data) {
  return (dispatch) => {
    return apiClient
      .put(`/users/${userId}`, { user: data })
      .then((updatedUser) => {
        dispatch(userFetched(updatedUser));
        return updatedUser;
      });
  };
}

function deleteUser(userId) {
  return (dispatch) => {
    return apiClient.delete(`/users/${userId}`).then(() => {
      dispatch(userDeleted(userId));
      return userId;
    });
  };
}

function fetchUser(userId, force = true) {
  return (dispatch, getState) => {
    if (!force) {
      const state = getState();
      return state.users.usersById[userId];
    }

    const path = `users/${userId}`;
    return apiClient.get(path).then((user) => {
      dispatch(userFetched(user));

      return user;
    });
  };
}

function fetchUsers(includeInactive = false) {
  return (dispatch, getState) => {
    const state = getState();
    const companyId = state.user.company_id;
    const path = `companies/${companyId}/users`;
    return apiClient.get(path, { includeInactive }).then((users) => {
      dispatch(usersFetched(users));

      return users;
    });
  };
}

function userImageStats(userId) {
  return () => {
    return apiClient.get(`users/${userId}/image_stats`);
  };
}

function updateProfilePhoto(userId, imageUri) {
  return (dispatch) => {
    const params = {
      image: imageUri,
      degrade: true,
    };
    return apiClient
      .post(`users/${userId}/profile_photo`, params)
      .then((user) => {
        dispatch(userFetched(user));
        return user;
      });
  };
}

export {
  createUser,
  updateUser,
  deleteUser,
  fetchUser,
  fetchUsers,
  userImageStats,
  updateProfilePhoto,
};
